import { render, staticRenderFns } from "./SeatTab.vue?vue&type=template&id=927bd9e0&scoped=true"
import script from "./SeatTab.vue?vue&type=script&lang=js"
export * from "./SeatTab.vue?vue&type=script&lang=js"
import style0 from "./SeatTab.vue?vue&type=style&index=0&id=927bd9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927bd9e0",
  null
  
)

export default component.exports